import React, { useContext } from "react"

import { useLocalization } from "@izettle/tenko-react"

import { CONTACT_INFORMATION_PROCESSING_LINK } from "@/config/environment"
import { ConfigContext } from "@/core/context/config"
import { availableLinkLocales, defaultLocale } from "@/core/utils/constant"
import { getSupportedLocale } from "@/core/utils/get-supported-locale"
import { FaqTitle, Footer, FooterLink, FooterLinkWrapper } from "@/modules/opt-out/styles"

export const OptOutFooter = () => {
  const config = useContext(ConfigContext)
  const linkLocale = getSupportedLocale(
    config.locale,
    availableLinkLocales,
    defaultLocale,
  ).territory.toLowerCase()
  const { text } = useLocalization()
  return (
    <Footer>
      <FaqTitle>{text("FAQ")}</FaqTitle>
      <FooterLinkWrapper>
        <FooterLink
          target="_blank"
          rel="noopener noreferrer"
          href={CONTACT_INFORMATION_PROCESSING_LINK.replace("{0}", linkLocale)}
        >
          {text("CONTACT_DETAILS_HANDLING_INFO_LINK")}
        </FooterLink>
      </FooterLinkWrapper>
      <FooterLinkWrapper>
        <FooterLink
          target="_blank"
          rel="noopener noreferrer"
          href={text("OPT_OUT_PRIVACY_POLICY_URL")}
        >
          {text("OPT_OUT_PRIVACY_POLICY_LINK_TEXT")}
        </FooterLink>
      </FooterLinkWrapper>
    </Footer>
  )
}
